<div class="stocks-etfs-search-modal" tabindex="0">
   <header class="d-flex align-items-center justify-content-between gap-3 py-0 stocks-etfs-search-header content-padding overflow-hidden">
      <form class="d-flex align-items-center flex-grow-1 search-form" [formGroup]="searchStocksAndEtfs" autocomplete="off">
         <svg class="search-svg flex-shrink-0" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
            <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m15 15 1.5 1.5m.433 2.525a1.48 1.48 0 1 1 2.092-2.092l2.042 2.042a1.48 1.48 0 1 1-2.092 2.092zM16.5 9.5a7 7 0 1 0-14 0 7 7 0 0 0 14 0"/>
         </svg>
         <input 
            #searchInput
            type="text" 
            class="flex-grow-1 border-0 form-control search-input shadow-none rounded-3 p-3" 
            placeholder="Search Stocks & ETFs"
            [value]="searchStocksAndEtfs.get('stockName')?.value"
         >
         <button #clearBtn type="button" class="border-0 py-1 px-2 rounded-3 border-0 clear-btn">
            Clear
         </button>
      </form>
      <button #closeBtn type="button" class="border-0 p-1 rounded-3 flex-shrink-0 search-close-btn">
         <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
            <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M18 6 6 18m12 0L6 6"/>
         </svg>
      </button>
   </header>

   <div class="d-grid content-padding asset-type-wrapper">
      <h3 class="lh-sm fw-500 text-uppercase">Asset Type</h3>
      <ul role="list" class="d-flex align-items-center gap-2 mb-0">
         <li>
            <button #allTab [class.active]="assetType === 'ALL'" class="rounded-3 search-tab-btn">
               All
            </button>
         </li>
         <li>
            <button #stocksTab [class.active]="assetType === 'STOCK'" class="rounded-3 search-tab-btn">
               Stocks
            </button>
         </li>
         <li>
            <button #etfsTab [class.active]="assetType === 'ETF'" class="rounded-3 search-tab-btn">
               ETFs
            </button>
         </li>
      </ul>
   </div>

   <div #resultsContainer class="position-relative stocks-etfs-search-body-results p-0">

      <!-- ✅ POPULAR ASSETS LOADER -->
      <ul *ngIf="loadingTopAssets && !isSearchMode" role="list" class="result-loader results-padding d-grid gap-2 mb-0">
         <li *ngFor="let i of loaderItems; trackBy: trackByIndex" class="result-loader-item skeleton-loader"></li>
      </ul>

      <!-- 🔵 SEARCH LOADER -->
      <ul *ngIf="searching" role="list" class="result-loader results-padding d-grid gap-2 mb-0">
         <li *ngFor="let i of loaderItems; trackBy: trackByIndex" class="result-loader-item skeleton-loader"></li>
      </ul>

      <div *ngIf="dataAvailable && !searching" class="results-padding pt-0">
         <h3 class="mb-0 lh-sm fw-500 text-uppercase position-sticky top-0 start-0 bg-white" *ngIf="!isSearchMode && !loadingTopAssets">
            Top Assets
         </h3>
         <h3 class="mb-0 lh-sm fw-500 text-uppercase position-sticky top-0 start-0 bg-white" *ngIf="isSearchMode">
            Results <span>({{ filteredResults.length }})</span> 
         </h3>
         <ul role="list" class="d-grid mb-0 gap-1 gap-md-0">
            <li 
               #resultItem
               *ngFor="let item of filteredResults; let i = index; trackBy: trackBySearchResult"
               [attr.data-index]="i"
               class="d-grid gap-1 gap-md-2 align-items-center result-item" 
               [class.active]="i === activeIndex"
            >
               <div class="company-image-wrapper d-none d-md-flex align-items-center fw-500 justify-content-center bg-white border rounded-circle overflow-hidden">
                  <span *ngIf="!item.logo">{{ item.companyName?.charAt(0) }}</span>
                  <img [src]="item.logo" [alt]="item.companyName" class="img-fluid rounded-circle bg-light" *ngIf="item.logo">
               </div>

               <div class="d-flex flex-column gap-1">
                  <h5 class="fw-500 mb-0 lh-sm line-clamp-1">{{ item.companyName }}</h5>
                  <div class="mb-0 d-flex align-items-center gap-2 lh-sm d-block fw-300">
                     <span class="d-block stock-name text-nowrap line-clamp-1">{{ item.stockName }}</span>
                     <div class="d-flex d-md-none">
                        <ng-container
                           *ngTemplateOutlet="complianceChip; context: {
                              complianceKey: item.complianceKey,
                              complianceText: item.complianceText,
                              ratingKey: item.ratingKey,
                              ratingText: item.ratingText,
                              isStatusLocked: item.isStatusLocked,
                              isRatingLocked: item.isRatingLocked
                           }">
                        </ng-container>
                     </div>
                  </div>
               </div>

               <div class="d-none d-md-flex align-items-center gap-1 lh-sm">
                  <ng-container
                     *ngTemplateOutlet="complianceChip; context: {
                        complianceKey: item.complianceKey,
                        complianceText: item.complianceText,
                        ratingKey: item.ratingKey,
                        ratingText: item.ratingText,
                        isStatusLocked: item.isStatusLocked,
                        isRatingLocked: item.isRatingLocked
                     }">
                  </ng-container>
               </div>

               <div class="d-flex gap-2 align-items-center justify-content-end company-exchange">
                  <span class="d-inline-block text-truncate lh-sm">{{ item.exchange }}</span>
                  <img [src]="'/assets/flags/1x1/' + item.flag + '.svg'" width="20" height="20" alt="" class="rounded-circle flex-shrink-0 d-block border img-fluid">
               </div>
            </li>
         </ul>
      </div>
      

      <div *ngIf="!dataAvailable && !searching && !loadingTopAssets" class="d-flex gap-2 flex-column align-items-center justify-content-center text-center results-padding no-data-wrapper">
         <img src="/assets/images/modal/search-no-data.webp" width="160" height="160" class="mx-auto img-fluid mb-3" alt="No Data">
         <h4 class="mb-0 fw-600">No results found</h4>
         <p class="mb-0">{{ noResultsMessage }}</p>
      </div>
   </div>

</div>

<!-- CONTEXT MENU -->
<div 
   *ngIf="contextMenuVisible" 
   class="custom-context-menu" 
   [style.left.px]="contextMenuPosition.x" 
   [style.top.px]="contextMenuPosition.y"
>
   <ul role="list" class="mb-0 p-0">
      <li #openNewTabBtn>
         <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
            <polyline points="15 3 21 3 21 9"></polyline>
            <line x1="10" y1="14" x2="21" y2="3"></line>
         </svg>
         Open in new tab
      </li>
   </ul>
</div>

<ng-template
   #complianceChip
   let-complianceKey="complianceKey"
   let-complianceText="complianceText"
   let-ratingKey="ratingKey"
   let-ratingText="ratingText"
   let-isStatusLocked="isStatusLocked"
   let-isRatingLocked="isRatingLocked"
>
   <div class="d-flex align-items-center gap-1">

      <!-- STATUS -->
      <ng-container *ngIf="!isStatusLocked; else statusLocked">
         <span
            class="d-flex align-items-center justify-content-center compliance-chip compliance-status-chip text-uppercase text-center rounded fw-500 lh-1"
            [ngClass]="{
               'compliant': complianceKey === 'COMPLIANT',
               'non-compliant': complianceKey === 'NON_COMPLIANT',
               'questionable': complianceKey === 'QUESTIONABLE',
               'not-covered': complianceKey === 'NOT_UNDER_COVERAGE'
            }"
         >
            {{ complianceText }}
         </span>
      </ng-container>

      <ng-template #statusLocked>
         <span class="position-relative d-flex align-items-center justify-content-center gap-1 compliance-chip compliance-status-chip text-uppercase text-center locked rounded fw-500 lh-1 cursor-pointer pricing-trigger">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24">
               <g fill="none" stroke="currentColor" stroke-width="2.5">
                  <path stroke-linecap="round" d="M12 16.5v-2"/>
                  <path d="M4.268 18.845c.225 1.67 1.608 2.979 3.292 3.056 1.416.065 2.855.099 4.44.099s3.024-.034 4.44-.1c1.684-.076 3.067-1.385 3.292-3.055.147-1.09.268-2.207.268-3.345s-.121-2.255-.268-3.345c-.225-1.67-1.608-2.979-3.292-3.056A95 95 0 0 0 12 9c-1.585 0-3.024.034-4.44.1-1.684.076-3.067 1.385-3.292 3.055C4.12 13.245 4 14.362 4 15.5s.121 2.255.268 3.345Z"/>
                  <path stroke-linecap="round" stroke-linejoin="round" d="M7.5 9V6.5a4.5 4.5 0 0 1 9 0V9"/>
               </g>
            </svg>
            locked

            <!-- Shariah Compliance Status tooltip -->
            <span class="position-absolute text-capitalize cust-tooltip fw-normal rounded-2 px-3 py-2 bg-dark text-white">
               Unlock Shariah Compliance Status
               <svg width="1.5em" height="1em" viewBox="0 0 16 16" class="position-absolute top-100 start-50 translate-middle bi bi-caret-down-fill" fill="currenctColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
               </svg>
            </span>
         </span>
      </ng-template>

      <!-- RATING -->
      <!-- Visible if Locked (shows lock) OR if Compliant (shows value) -->
      <ng-container *ngIf="isRatingLocked || (complianceKey === 'COMPLIANT' && ratingKey !== 0)">
         <span class="vr"></span>
         <ng-container *ngIf="!isRatingLocked; else ratingLocked">
            <span class="d-flex align-items-center justify-content-center compliance-chip compliance-rating-chip text-uppercase text-center compliant rounded fw-500 lh-1" >
               {{ ratingText }}
            </span>
         </ng-container>

         <ng-template #ratingLocked>
            <span class="position-relative d-flex align-items-center justify-content-center compliance-chip compliance-rating-chip text-uppercase text-center locked rounded fw-500 lh-1 cursor-pointer pricing-trigger">
               <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24">
                  <g fill="none" stroke="currentColor" stroke-width="2.5">
                     <path stroke-linecap="round" d="M12 16.5v-2"/>
                     <path d="M4.268 18.845c.225 1.67 1.608 2.979 3.292 3.056 1.416.065 2.855.099 4.44.099s3.024-.034 4.44-.1c1.684-.076 3.067-1.385 3.292-3.055.147-1.09.268-2.207.268-3.345s-.121-2.255-.268-3.345c-.225-1.67-1.608-2.979-3.292-3.056A95 95 0 0 0 12 9c-1.585 0-3.024.034-4.44.1-1.684.076-3.067 1.385-3.292 3.055C4.12 13.245 4 14.362 4 15.5s.121 2.255.268 3.345Z"/>
                     <path stroke-linecap="round" stroke-linejoin="round" d="M7.5 9V6.5a4.5 4.5 0 0 1 9 0V9"/>
                  </g>
               </svg>

               <!-- Musaffa Halal Rating tooltip -->
               <span class="position-absolute text-capitalize cust-tooltip fw-normal rounded-2 px-3 py-2 bg-dark text-white">
                  Unlock Musaffa Halal Rating
                  <svg width="1.5em" height="1em" viewBox="0 0 16 16" class="position-absolute top-100 start-50 translate-middle bi bi-caret-down-fill" fill="currenctColor" xmlns="http://www.w3.org/2000/svg">
                     <path d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                  </svg>
               </span>
            </span>
         </ng-template>

      </ng-container>

   </div>
</ng-template>
